import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppComponent } from './app.component';
import { BreadcrumbService } from './breadcrumb.service';
import { Subscription } from 'rxjs/Subscription';
import { MenuItem } from 'primeng/primeng';
import { TranslatePipe, TranslateService, LangChangeEvent } from 'ng2-translate';
import { AuthenticationService } from './providers/authentication/authentication.service';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { EntityManagerProvider } from './providers/entity-manager-provider/entity-manager-provider';
import { Constantes } from './domain/constantes';
import { PermisosService } from './providers/authentication/permisos.service';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html',
	providers: [ConfirmationService]
})

export class AppBreadcrumbComponent implements OnDestroy {

    subscription: Subscription;

    items: MenuItem[];
    
    espacioSeleccionado: any;
    permisosService: PermisosService;


    constructor(
                  public breadcrumbService: BreadcrumbService,
                  public authService: AuthenticationService,
				  private router: Router,
				  private translate: TranslateService,
                  private confirmationService: ConfirmationService,
                  private entityManager: EntityManagerProvider
	){
        
        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            const that = this;
            const idEspacio = that.authService.getIdEspacio();
            this.entityManager.getEspacioById(idEspacio)
            .then(function(espacio){
                that.items = response;
                that.espacioSeleccionado = espacio;
            });
            /*this.entityManager.getFUNCIONALIDADESbyUSUARIO(that.espacioSeleccionado.Id)
		    .then(function(funcionalidades){
			return that.permisosService.getMenu(funcionalidades);
		    });*/
           
        });
    
    }

    logout() {
		this.confirmationService.confirm({
			message: this.translate.instant('MensajesConfirmacion.MENSAJE_LOGOUT'),
			header: this.translate.instant('MensajesConfirmacion.MENSAJE_CABECERA_CONFIRMACION'),
			icon: 'fa fa-question-circle',
			accept: () => {
				this.authService.logout();
				this.router.navigate(['/']);
			},
			reject: () => {

			}
		});
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/app.breadcrumb.component.ts